import React from 'react';
import CnListView from './cn-list';
class CnList extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }
    render() {
        return React.createElement(CnListView, { ref: this.ref, ...this.props });
    }
}
CnList.displayName = 'CnList';
export default CnList;
export { CnList };
